// Resume-aligned + latest frontend tech
export const frontSkillsList = [
  { label: "HTML5", src: "https://img.icons8.com/color/480/000000/html-5--v1.png" },
  { label: "CSS3", src: "https://img.icons8.com/color/480/000000/css3.png" },
  { label: "JavaScript", src: "https://img.icons8.com/color/480/000000/javascript.png" },
  { label: "TypeScript", src: "https://img.icons8.com/color/480/000000/typescript.png" },
  { label: "React", src: "https://img.icons8.com/color/480/000000/react-native.png" },
  { label: "Next.js", src: "https://img.icons8.com/color/480/000000/nextjs.png" },
  { label: "Redux", src: "https://img.icons8.com/color/480/000000/redux.png" },
  { label: "React Router", src: "https://img.icons8.com/color/480/000000/react-native.png" },
  { label: "Tailwind CSS", src: "https://img.icons8.com/color/480/000000/tailwindcss.png" },
  { label: "Vite", src: "https://cdn.simpleicons.org/vite/646CFF" },
  { label: "MUI", src: "https://cdn.simpleicons.org/mui/007FFF" },
  { label: "NPM", src: "https://img.icons8.com/color/480/000000/npm.png" },
];

// Backend + APIs + languages from resume
export const backSkillsList = [
  { label: "Node.js", src: "https://img.icons8.com/color/480/000000/nodejs.png" },
  { label: "Express", src: "https://i.ibb.co/9smDM6j/pngegg.png" },
  { label: "MongoDB", src: "https://i.ibb.co/ZVh01dm/rsz-mong2.png" },
  { label: "MySQL", src: "https://img.icons8.com/fluent/480/000000/mysql-logo.png" },
  { label: "GraphQL", src: "https://img.icons8.com/color/480/000000/graphql.png" },
  { label: "REST API", src: "https://img.icons8.com/color/480/000000/api-settings.png" },
  { label: "Python", src: "https://img.icons8.com/color/480/000000/python.png" },
];

// Tools, collaboration & AI (resume + current stack)
export const toolsAndAiList = [
  { label: "Figma", src: "https://img.icons8.com/color/480/000000/figma--v1.png" },
  { label: "JIRA", src: "https://img.icons8.com/color/480/000000/jira.png" },
  { label: "Trello", src: "https://img.icons8.com/color/480/000000/trello.png" },
  { label: "Git", src: "https://img.icons8.com/color/480/000000/git.png" },
  { label: "GitHub", src: "https://img.icons8.com/color/480/000000/github.png" },
  { label: "Cursor", src: "https://cdn.simpleicons.org/cursor/000" },
  { label: "GitHub Copilot", src: "https://cdn.simpleicons.org/githubcopilot/000" },
  { label: "Claude", src: "https://img.icons8.com/color/480/000000/artificial-intelligence.png" },
  { label: "ChatGPT", src: "https://img.icons8.com/color/480/000000/chatgpt.png" },
];

export const projectsList = [
  // Professional work @ Solute Technolabs
  {
    label: "FSI Admin Portal",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://admin.assetconnect.app/",
    githubSrc: null,
    description:
      "Enterprise React 18 + TypeScript admin SPA (Vite) for fire suppression operations at FSI Australia. Role-based access, asset management with real-time monitoring, Chart.js/Syncfusion visualizations, Redux Toolkit (100+ slices), knowledge library, timesheet flows, and Firebase FCM.",
    features: [
      "Role-based access (FSI Admin, Distributor, Company Client)",
      "Asset management with PID data & CSV export",
      "Knowledge library with folder tree, versions, search",
      "MUI 5, SCSS, Sentry",
    ],
    stack: ["React", "TypeScript", "Redux Toolkit", "Vite", "MUI", "Firebase"],
    client: {
      name: "FSI – Fire & Safety Industries",
      location: "Australia",
      aboutUrl: "https://fireandsafety.com.au/about-us/",
    },
  },
  {
    label: "Roche EP Evaluator",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://web.rdkk.platform.navify.com/",
    githubSrc: null,
    description:
      "Led frontend for a laboratory statistics application (Japan) for clinical lab method evaluation. Editable 2D data grid with collapsible row-groups, interactive graphs, SSO, and multi-language (Japanese/English).",
    features: [
      "2D editable data grid with copy/cut/paste/clear",
      "SSO integration",
      "REST APIs, report PDF generation",
      "Japanese & English support",
    ],
    stack: ["React", "REST API", "SSO"],
    client: {
      name: "Roche",
      location: "Japan",
      aboutUrl: "https://www.roche.com/about",
    },
  },
  {
    label: "Odds Now",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://www.oddsnow.com/",
    githubSrc: null,
    description:
      "Content-driven sports odds platform (London) with Next.js 15 App Router and Sanity CMS. Custom schemas, draft mode, Sanity Live preview, CDN/cache strategy, GA4/GTM/AdSense, Portable Text with custom embeds.",
    features: [
      "Next.js 15, Sanity CMS, multi-dataset admin",
      "SEO, dynamic metadata, Open Graph",
      "Performance: deduplication, dynamic imports, Turbopack",
    ],
    stack: ["Next.js", "Sanity CMS", "TypeScript", "GA4", "GTM"],
    client: {
      name: "OddsNow",
      location: "London",
      aboutUrl: "https://www.oddsnow.com/about-us",
    },
  },
  {
    label: "Amagi Connect",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://connect.amagiengg.io/",
    githubSrc: null,
    description:
      "Amagi's FAST marketplace (Bengaluru)—800+ content owners, 3,000+ channel deliveries, 200M+ CTV households. Built UIs for content and platform partners, delivery tracker, and signup/login flows.",
    features: [
      "Content & platform partner UIs",
      "Performance optimization & page caching",
      "End-to-end signup/login flows",
    ],
    stack: ["React", "Performance", "Caching"],
    client: {
      name: "Amagi",
      location: "Bengaluru, India",
      aboutUrl: "https://www.amagi.com/about",
    },
  },
  {
    label: "Deccan Herald / Prajavani SSO",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://www.deccanherald.com/",
    githubSrc: null,
    description:
      "Multi-tenant SSO web app (React, Tailwind) for 550K+ users across two brands. SuperTokens (ThirdPartyPasswordless + Session), OTP, magic link, social login (Google, Apple), Google One Tap.",
    features: [
      "Multi-tenant with tenant-specific branding",
      "Email/phone OTP, magic link, social login",
      "Formik, semantic HTML, accessibility",
    ],
    stack: ["React", "Tailwind", "SuperTokens", "Formik"],
    client: {
      name: "Deccan Herald & Prajavani (The Printers Mysore)",
      location: "Karnataka, India",
      aboutUrl: "https://www.printersmysore.com/",
    },
  },
  {
    label: "VTV Gujarati",
    imgSrc: ["images/marvel1.jpg"],
    src: "https://www.vtvgujarati.com/",
    githubSrc: null,
    description:
      "End-to-end high-traffic news website (Gujarat). Responsive, mobile-first, SEO (semantic HTML, structured data), image optimization, lazy loading, code splitting, and live news streaming.",
    features: [
      "Fully responsive, mobile-first",
      "SEO, Core Web Vitals",
      "Live TV and breaking news streaming",
    ],
    stack: ["React", "SEO", "Performance"],
    client: {
      name: "VTV Gujarati",
      location: "Gujarat, India",
      aboutUrl: "https://www.vtvgujarati.com/about-us",
    },
  },
];
// https://developer.marvel.com/